// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offer-modaloffer-modal {
  padding-inline: 90px;
}
.make-offer-txt {
  font-size: 23px;
  color: #0a0f0d;
  font-weight: 700;
}
.make-offer-container {
  margin-top: 30px;
  width: 100%;
  overflow-y: scroll;
}
.offer-modal .ant-modal-content {
  padding-bottom: 0.5rem;
}
.make-offer-container-space {
  height: 55vh !important;
  overflow-y: scroll;
}
.campaign-offer-text {
  font-size: 16px;
  font-weight: 400px;
  color: #3b3f3d;
}
.make-offer-container .campaign-product {
  margin-bottom: 0.5rem;
}
.add-comment-btn {
  background-color: #f0f0f0;
  height: 40px;
  width: auto;
  border: none;
}
.add-comment-btn-text {
  color: #000000;
  font-weight: 600;
}
.add-comment-btn-text:hover {
  color: #000000 !important;
  font-weight: 600;
  width: auto !important;
}
.add-comment-btn:hover {
  background-color: #f0f0f0 !important;
  height: 40px;
  width: auto !important;
}
.campaign-product-name {
  font-size: 1rem;
  color: #000000;
  font-weight: 500;
}
.offer-Submit-btn {
  background-color: #d2042d;
  height: 40px;
  width: 160px;
  border: none;
  margin-top: 1rem;
}
.offer-Submit-btn-text {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}
.offer-Submit-btn:hover {
  background-color: #d2042d !important;
  height: 40px;
  width: 160px;
}
.offer-Submit-btn:disabled {
  background-color: #d2042d !important;
  opacity: 0.6;
}
.make-offer-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px !important;
  display: inline-block;
}
.add-comment-col {
  display: flex;
  align-items: end;
  justify-content: end;
}
.offer-modal .ant-input-outlined {
  background: #ffffff;
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
  border-top: none;
  border-left: none;
  border-right: none;
}

.make-offer-container-space {
  height: 500px;
  width: 100%;
}

.no-offer-card {
  background: #f5f5f5;
  width: 378px;
  height: 200px;
  margin: 1rem 0;
  font-size: 1rem;
  align-items: center;
  display: flex;
  justify-content: center;
}
.ant-tabs-ink-bar {
  border-bottom: 4px solid #d2042d !important;
}
.ant-tabs-tab:hover {
  color: #8e9190 !important; /* Replace with your desired hover color */
}

.submitted-label {
  margin-top: 0.5rem;
  margin-bottom: 0.8rem;
  font-size: 16px;
  font-weight: 400;
  color: #3b3f3d;
}
.offer-numbers {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000;
  margin-bottom: 0.6rem;
}
.my-offer-requests .offer-card {
  margin-bottom: 20px;
  background: #f5f5f5;
}
.offer-label {
  font-family: Roboto;
  color: #5b5e5d;
  font-size: 16px;
  font-weight: 400;
}
.product-comments-label {
  color: #5b5e5d;
  font-size: 13px;
  font-weight: 400;
}
.comments {
  margin-top: 22px;
}
.offer-status {
  color: #d2042d;
  font-size: 16px;
  font-weight: 400;
}
.price-value {
  font-weight: 600;
  color: #000;
  margin-left: 0.2rem;
}
.offer-comments {
  font-family: Roboto;
  color: #0a0f0d;
  font-weight: 400;
  font-size: 16px;
}
.offer-status-accept {
  color: green !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/make-offer-modal/MakeOffer.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,yBAAyB,EAAE,0CAA0C;AACvE;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".offer-modaloffer-modal {\n  padding-inline: 90px;\n}\n.make-offer-txt {\n  font-size: 23px;\n  color: #0a0f0d;\n  font-weight: 700;\n}\n.make-offer-container {\n  margin-top: 30px;\n  width: 100%;\n  overflow-y: scroll;\n}\n.offer-modal .ant-modal-content {\n  padding-bottom: 0.5rem;\n}\n.make-offer-container-space {\n  height: 55vh !important;\n  overflow-y: scroll;\n}\n.campaign-offer-text {\n  font-size: 16px;\n  font-weight: 400px;\n  color: #3b3f3d;\n}\n.make-offer-container .campaign-product {\n  margin-bottom: 0.5rem;\n}\n.add-comment-btn {\n  background-color: #f0f0f0;\n  height: 40px;\n  width: auto;\n  border: none;\n}\n.add-comment-btn-text {\n  color: #000000;\n  font-weight: 600;\n}\n.add-comment-btn-text:hover {\n  color: #000000 !important;\n  font-weight: 600;\n  width: auto !important;\n}\n.add-comment-btn:hover {\n  background-color: #f0f0f0 !important;\n  height: 40px;\n  width: auto !important;\n}\n.campaign-product-name {\n  font-size: 1rem;\n  color: #000000;\n  font-weight: 500;\n}\n.offer-Submit-btn {\n  background-color: #d2042d;\n  height: 40px;\n  width: 160px;\n  border: none;\n  margin-top: 1rem;\n}\n.offer-Submit-btn-text {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n}\n.offer-Submit-btn:hover {\n  background-color: #d2042d !important;\n  height: 40px;\n  width: 160px;\n}\n.offer-Submit-btn:disabled {\n  background-color: #d2042d !important;\n  opacity: 0.6;\n}\n.make-offer-truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 130px !important;\n  display: inline-block;\n}\n.add-comment-col {\n  display: flex;\n  align-items: end;\n  justify-content: end;\n}\n.offer-modal .ant-input-outlined {\n  background: #ffffff;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #d9d9d9;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n\n.make-offer-container-space {\n  height: 500px;\n  width: 100%;\n}\n\n.no-offer-card {\n  background: #f5f5f5;\n  width: 378px;\n  height: 200px;\n  margin: 1rem 0;\n  font-size: 1rem;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.ant-tabs-ink-bar {\n  border-bottom: 4px solid #d2042d !important;\n}\n.ant-tabs-tab:hover {\n  color: #8e9190 !important; /* Replace with your desired hover color */\n}\n\n.submitted-label {\n  margin-top: 0.5rem;\n  margin-bottom: 0.8rem;\n  font-size: 16px;\n  font-weight: 400;\n  color: #3b3f3d;\n}\n.offer-numbers {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #000;\n  margin-bottom: 0.6rem;\n}\n.my-offer-requests .offer-card {\n  margin-bottom: 20px;\n  background: #f5f5f5;\n}\n.offer-label {\n  font-family: Roboto;\n  color: #5b5e5d;\n  font-size: 16px;\n  font-weight: 400;\n}\n.product-comments-label {\n  color: #5b5e5d;\n  font-size: 13px;\n  font-weight: 400;\n}\n.comments {\n  margin-top: 22px;\n}\n.offer-status {\n  color: #d2042d;\n  font-size: 16px;\n  font-weight: 400;\n}\n.price-value {\n  font-weight: 600;\n  color: #000;\n  margin-left: 0.2rem;\n}\n.offer-comments {\n  font-family: Roboto;\n  color: #0a0f0d;\n  font-weight: 400;\n  font-size: 16px;\n}\n.offer-status-accept {\n  color: green !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
